module.exports = __webpack_public_path__ + "static/img/2.92b0179.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-fr/2.jpg
// module id = zi9h
// module chunks = 1